const stripRichText = (text: string | undefined) => {
  if (!text) {
    return "";
  }
  return text.replace(/<p>|<\/p>/g, "").replace(/&nbsp;/g, " ");
};

export default stripRichText;
